<div class="login-holder">
  <div class="text-container mat-elevation-z8">
    <p class="centered-text">Välkommen till tjänsten fotoadmin. För att kunna använda tjänsten behöver ni först
      identifiera er med BankID.</p>
    <jhc-bankid (accessToken)="configService.setToken($event)" [bankIdUrl]="bankIdUrl"></jhc-bankid>
  </div>
</div>

